import { ChangeDetectionStrategy, ChangeDetectorRef, Component, input, Input, OnDestroy, OnInit } from "@angular/core";
import { NzModalService } from "ng-zorro-antd/modal";
import { WebhookFormInputComponent } from "../webhook-form-input/webhook-form-input.component";
import { WebhookCommonComponent } from "../common.components";
import { NumberFormatterService, NumberFormatConfig } from "src/app/builder-screen-beta/services/number-formatter.service";
import { FormulaServices } from "src/app/services/formula.service";
import { FormulaTSService } from "src/app/services/formula-ts.service";
import { DynamicLoaderService } from "src/app/services/dynamic-loader.service";
import { WebHookCommonServices } from "../../webhook-services/webhook-commom.services";
import { LanguageServices } from "src/app/services/LanguageServices";

@Component({
    selector: 'webhook-form-number',
    templateUrl: './webhook-form-number.component.html',
    styleUrl: './webhook-form-number.component.scss',
    standalone: false
})

export class WebhookFormNumberComponent extends WebhookCommonComponent implements OnInit, OnDestroy {
   
  constructor(
    private numberFormatter: NumberFormatterService,
    modalService: NzModalService,
    formulaServices: FormulaServices,
    tsFormula: FormulaTSService,
    cd: ChangeDetectorRef,
    dynamicLoader: DynamicLoaderService,
    commomServices: WebHookCommonServices,
    translate: LanguageServices
  ) {
    super(modalService, formulaServices, tsFormula, cd, dynamicLoader, commomServices, translate);
  }

  /**
   * Função de formatação para nz-input-number (nzFormatter)
   * Converte número para string formatada (ex: 1234567.89 -> "1.234.567,89")
   */
  nzFormatter = (value: number): string => {
    if (!this.field) return String(value ?? '');
    
    const config: NumberFormatConfig = {
      decimalPlaces: this.field.decimalPlaces ?? 2,
      formatThousands: this.field.formatThousands ?? false,
      thousandSeparator: this.field.thousandSeparator ?? '.',
      decimalSeparator: this.field.decimalSeparator ?? ','
    };
    
    return this.numberFormatter.format(value, config);
  };

  /**
   * Função de parse para nz-input-number (nzParser)
   * Converte string formatada para string numérica JS (ex: "1.234.567,89" -> "1234567.89")
   *
   * IMPORTANTE: Retorna STRING (não número). O nz-input-number legacy espera string
   * para poder detectar entradas parciais como "55." e manter o ponto no input
   * enquanto o usuário continua digitando as casas decimais.
   */
  nzParser = (value: string): string => {
    if (!this.field) return value;
    
    const config: NumberFormatConfig = {
      thousandSeparator: this.field.thousandSeparator ?? '.',
      decimalSeparator: this.field.decimalSeparator ?? ','
    };
    
    return this.numberFormatter.parseForInput(value, config);
  };

}